const addEnquiryListener = (modal) => {
  if(!!document.getElementById('enquire-now')) {
    document.getElementById('enquire-now').addEventListener('click', function(evt){
      evt.preventDefault();
      const product_id = this.dataset.product_id;
      const targetElement = document.getElementById(`#bonk-contact-${product_id}`);

      let scrollTarget, yOffset = 0, offset = 0;
      if (!targetElement.classList.contains('is-open')) {
        targetElement.click();
      }
      if(modal){
        scrollTarget = document.querySelector(`#bonk-contact-${product_id} button[type=submit]`);
        scrollTarget.scrollIntoView({behavior: "smooth", block: "start"});
      }else {
        scrollTarget = window;
        yOffset = scrollTarget.pageYOffset
        offset = targetElement.getBoundingClientRect().top + yOffset - 150;
        scrollTarget.scrollTo({behavior: "smooth", top: offset});
      }
    });
  }
};

document.addEventListener('quickview:loaded', function() {
  addEnquiryListener(true);
});
document.addEventListener('page:loaded', function() {
  addEnquiryListener(false);
});
